import React, { useState, useEffect } from 'react';
import '../css/Header.css';
import '../css/Body.css';

/* 폰트어썸 import */
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import MapContainer from './CustomerMapContainer';
import { getUserAccount, getIsLogin, clearSession } from '../utils/session';

// import faqsData from "../data/faqs.json";  // ① JSON 파일 import

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))
(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
    borderBottom: 0,
    },
    '&:before': {
    display: 'none',
    },
}));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
))
(({ theme }) => ({
    backgroundColor:
    theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
    },
}));
  
const AccordionDetails = styled(MuiAccordionDetails)
(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function Customer() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();

    const onLogoutHandler = (event) => {
        event.preventDefault();
        clearSession();
        window.location.replace('/');
    };
    // console.log("설정 - isLogin", isLogin);

    // const [expanded, setExpanded] = React.useState('panel1');

    // const handleChange = (panel) => (event, newExpanded) => {
    //     setExpanded(newExpanded ? panel : false);
    // };

    const [faqsData, setFaqsData] = useState([]);
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        // isLogin 은 boolean 이므로 문자열 비교(`!== "OK"`) 는 항상 참이 되는 회귀를 피한다.
        if (!isLogin) {
            navigate('/Login');
            return;
        }
    }, []);

    // public/data/faqs.json 불러오기
    useEffect(() => {
        fetch('/data/faqs.json')
        .then((res) => {
            if (!res.ok) throw new Error('FAQ 로딩 실패');
            return res.json();
        })
        .then((data) => setFaqsData(data))
        .catch((err) => console.error(err));
    }, []);
    
    return (
        <div className="container">
            <div className="header-wrap">
                <h1>고객지원</h1>
                <div className="input-seach">
                {/*
                    <input type="text" id="Seach" name="검색" placeholder="검색어를 입력해주세요."/>
                    <FontAwesomeIcon className="seach-icon" icon={faMagnifyingGlass} />
                */}
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{userAccount.company}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {userAccount.email}
                    </div>
                </div>
            </div>

            <div className="body-wrap-customer">
                <div className="customer-grop-1">
                    <div className="customer-layout-1">
                        <div className="customer-layout-header">
                            <h3>고객지원 센터</h3> <span>Customer Support Center</span>
                        </div>  
                        <div className="csLayoutBody1">
                            <div className="textInputListNone">
                                상호
                                <input className="textInput2" type="text" disabled="disabled" value="SEMIQUZ" />
                            </div>
                            <div className="textInputListNone">
                                주소
                                <input className="textInput2" type="text" disabled="disabled" value="경기 평택시 고덕중앙로 200-4(고덕동, 우성고덕타워)" />
                            </div>
                            <div className="textInputListNone">
                                전화번호
                                <input className="textInput2" type="text" disabled="disabled" value="070-4352-0624" />
                            </div>
                            <div className="csMap">
                                <p>오시는 길</p>
                                <div className="csMapWrap">
                                {
                                    userAccount &&
                                    <MapContainer userInfo={userAccount} />
                                }
                                </div>
                            </div>
                            <div className="textInputListNone">
                                사용설명서
                                <Button style={{backgroundColor: '#4e82eb' , borderRadius:'8px' , padding: '6px 64px', border: 'none' , color:'white'}} 
                                        variant="outlined">
                                        다운로드
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="customer-layout-2">
                        <div className="customer-layout-header">
                            <h3>자주묻는 질문</h3> <span>FAQ</span>
                        </div>
                        <div className="accordionLayout">
                        {faqsData.map((item) => (
                            <Accordion
                                key={item.id}
                                expanded={expanded === item.id}
                                onChange={handleChange(item.id)}
                            >
                                <AccordionSummary
                                aria-controls={`panel${item.id}-content`}
                                id={`panel${item.id}-header`}
                                style={{ backgroundColor: "#F5F6FF" }}
                                >
                                <Typography>{`${item.id}. ${item.question}`}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                <Typography style={{ whiteSpace: "pre-line" }}>
                                    {item.answer}
                                </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Customer;
